import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import { tcEventClickSearchEvent } from "../Actions/TagCommander.action"
import { toggleScrollLock } from '../Services/helpers';

const QuickSearch = props => {
    const { query, result, showResult, showFullForm, onSearch, onBlur, onKeyDown, toggleShowFullForm, showFullFormResults, selectedItem, searchUrl } = props;
    const searchInputRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isClosed, setIsClosed] = useState(false);
    const isFirstRender = useRef(true);
    const [isLoading, setIsLoading] = useState(false);

    useLayoutEffect(() => {
        // Used to prevent the first render from triggering the animation of the backdrop fade out
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } 
        else {
            if (showFullForm) {
                setIsOpen(true);
                setIsClosed(false);
                document.querySelector('#quickSearch').classList.add('quick-search--open');
                setTimeout(() => searchInputRef.current.focus(), 100);
                toggleScrollLock(true);
            } else {
                setIsOpen(false);
                setIsClosed(true);
                document.querySelector('#quickSearch').classList.remove('quick-search--open');
                toggleScrollLock(false);
            }
        }
    }, [showFullForm]); 

    useLayoutEffect(() => {
        setIsLoading(false);
    }, [result])

    const handleSearch = (query) => {
        setIsLoading(true)

        if (query == null || query.trim() == "")
            setIsLoading(false) // null or empty searches should not trigger the loader since it can cause server issue

        onSearch(query)
    }

    const handleClear = () => {
        if (query == null || query.trim() == "") 
            toggleShowFullForm()
        else 
            handleSearch("", true)
    }
    
    return (
        <form className={`quick-search__form 
            ${showFullForm ? 'quick-search__form--open' : ''}
            ${!isFirstRender.current && isClosed ? 'quick-search__form--closed' : ''}`} 
            role="search" method="get" action={searchUrl}>

            <div className={`quick-search__backdrop
                ${!isFirstRender.current && isOpen ? 'quick-search__backdrop--open' : ''}
                ${!isFirstRender.current && isClosed ? 'quick-search__backdrop--closed' : ''}`}
                onClick={() => isOpen && toggleShowFullForm()}>
            </div>

            <button className="quick-search__submit-button" type="submit" title="submit search" onClick={() => { 
                tcEventClickSearchEvent(query) 
            }}>
                <span className="quick-search__search-icon"></span>
            </button>

            <input name="q" className="quick-search__input" type="text" placeholder={translate('search.placeholder')}
                autoComplete="off" value={query} onFocus={e => showFullFormResults(true)} onChange={event => handleSearch(event.target.value)}
                onKeyDown={event => onKeyDown(event, {searchUrl})} ref={searchInputRef}
                onBlur={() => onBlur() }/>

            {
                showFullForm && !isLoading && (
                    <button className="quick-search__clear-button" type="button" title="clear search" onClick={() => handleClear()}>
                        <span className="quick-search__clear-icon"></span>
                    </button>
                )
            }

            {
                isLoading && <SearchLoader />
            }

            {
                showResult && (
                    <QuickSearchResult {...{
                        result,
                        selectedItem,
                        searchUrl,
                        toggleShowFullForm,
                        searchQuery: query
                    }} />
                )
            }

        </form>
    )
}

const SearchLoader = () => <div className="quick-search__loader button-loader button-loader--black"><div></div><div></div><div></div><div></div></div>

export default QuickSearch;